/** @jsx h */
import { h } from 'preact'

import JourneyCoverView from './CoverView'

const CoverViewContainer = props => (
  <JourneyCoverView {...props} url='#' preview />
)

export default CoverViewContainer
